import { render, staticRenderFns } from "./SocialsIndex.vue?vue&type=template&id=73090484&lang=pug"
import script from "./SocialsIndex.vue?vue&type=script&lang=js"
export * from "./SocialsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports